export default __webpack_public_path__ + "static/media/FS-HOME-ACERCA-BENEFICIO-COSTO-ICONO.db45ba2d.svg";